'use client';

import React from 'react';
import { css } from 'styled-system/css';

import ShaojiangLink from '@shaojiang/components/ShaojiangLink';
import ShaojiangTechIcon from '@shaojiang/components/ShaojiangTechIcon';
import { HoverCard } from '@shaojiang/components/ui/hover-card';
import useProjectByName from '@shaojiang/hooks/useProjectByName';

interface Props {
  workProject: string;
  children: React.ReactNode;
}

/** Project name that links to its details and shows its tech stack on hover. */
export default function ProjectWithTechs({ workProject, children }: Props) {
  const project = useProjectByName(workProject);

  if (!project) return <div className={css({ pl: '2' })}>- {children}</div>;

  return (
    <HoverCard.Root openDelay={150} closeDelay={100} positioning={{ placement: 'bottom' }}>
      <HoverCard.Trigger asChild>
        <ShaojiangLink href={`/projects/${project.slug}`} className={css({ pl: '2', my: '1' })}>
          - {children}
        </ShaojiangLink>
      </HoverCard.Trigger>
      <HoverCard.Positioner>
        <HoverCard.Content maxW='80' p='3' textAlign='left'>
          <p className={css({ mb: '3', textStyle: 'sm', color: 'fg.default' })}>
            Tech stack in Project `{workProject}`:
          </p>
          <div className={css({ display: 'flex', flexWrap: 'wrap' })}>
            {(project.tags || []).map((tag) => (
              <ShaojiangTechIcon
                key={tag}
                name={tag}
                className={css({ m: '1' })}
                width={32}
                height={32}
              />
            ))}
          </div>
        </HoverCard.Content>
      </HoverCard.Positioner>
    </HoverCard.Root>
  );
}
